import { mapShareContactDetailsList, mapShareContacts, ShareContact, ShareContactDetails } from "../ShareContactInterface";
import { mapSharedFolderBy, SharedFolderBy } from "../SharedFolderBy";

export interface Service {
    folder_id: number;
    project_id: number;
    folder: string;
    type: string;
    service_name: string;
    display_name: string;
    folder_type: string;
    add_default_id: number;
    assign: ShareContact[],
    contact: ShareContactDetails[],
    feature_name: string;
    feature_key_name: string;
    category?: 'Others' | 'Building Control' | null;
    shared_by: SharedFolderBy | null;
    file_path: string | null;
}

export const mapCustomService = (data: any): Service => {
    if (!data) {
        throw new Error('Invalied Custom Service map type')
    }

    const customService: Service = {
        folder_id: data.folder_id,
        project_id: data.project_id,
        folder: data.folder,
        type: data.type,
        service_name: data.service_name,
        display_name: data.display_name,
        folder_type: data.folder_type,
        add_default_id: data.add_default_id,
        assign: mapShareContacts(data.assign),
        contact: mapShareContactDetailsList(data.contact),
        feature_name: data.feature_name,
        feature_key_name: data.feature_key_name,
        category: data.category,
        shared_by: (data.shared_by !== null) ? mapSharedFolderBy(data.shared_by) : null,
        file_path: data.file_path !== null ? data.file_path : null
    }

    return customService;
}

export const mapCustomServices = (data: any[]): Service[] => {
    if (!Array.isArray(data)) {
        throw new Error('Invalid Custom Service data');
    }

    return data.map(mapCustomService);
};